<template>
  <!-- Sent on Peppol: its acknowledgement, the rejection reason on hover. -->
  <span
    v-if="invoice.peppol_sent_at && invoice.peppol_status"
    class="inline-flex shrink-0 items-center gap-1 rounded-sm px-1.5 py-0.5 text-xs font-medium whitespace-nowrap"
    :class="classes"
    :title="invoice.peppol_error ?? undefined"
  >
    <img :src="peppolLogo" alt="" class="h-3" />
    {{ $t(`enums.peppol_invoice_status.${invoice.peppol_status}`) }}
  </span>
</template>

<script>
import peppolLogo from '@/assets/images/partners/peppol.svg'

/** An invoice's Peppol acknowledgement: in progress, received, rejected. */
export default {
  name: 'PeppolStatusBadge',
  props: {
    invoice: { type: Object, required: true }
  },
  computed: {
    peppolLogo() {
      return peppolLogo
    },
    classes() {
      switch (this.invoice.peppol_status) {
        case 'Ok':
          return 'bg-green-100 text-green-800'
        case 'Error':
          return 'bg-red-100 text-red-800'
        default:
          return 'bg-amber-100 text-amber-800'
      }
    }
  }
}
</script>
